// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "362" ? "__federation_expose_App" : chunkId) + "." + {"362": "737013956c82bb90","779": "fca542fd80e0d882",}[chunkId] + ".chunk.css"
}